import { useState,useEffect } from "react";
import { motion,AnimatePresence } from "framer-motion";
import { BookOpen, Eye, User, FileText, Calendar, Users, Phone, Mail, MapPin, X, ChevronLeft, ChevronRight, Image as ImageIcon, Sparkles, ArrowRight, GraduationCap, ShieldCheck, Search, Clock3, ExternalLink } from "lucide-react";
import { ArrowUpRight,Clock,Building2  } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";
import PSACSection from '../components/PSACSection';
import AboutIQAC from '../components/AboutIQAC';

export default function IqacPage({ 
  accent = "#115e32",
  pageTitle = "The Institutional Quality Assurance Cell (IQAC) | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About IQAC", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director, IQAC", icon: <User size={18} /> },
    { id: "services", label: "Upcoming Training and Events", icon: <FileText size={18} /> },    
    { id: "gallery", label: "IQAC Gallery", icon: <Users size={18} /> },
	{ id: "news", label: "IQAC News", icon: <FileText size={18} /> },
	{ id: "team", label: "IQAC Team", icon: <User size={18} /> },
	{ id: "psac", label: "Program Staff Assessment Committee (PSAC)", icon: <User size={18} /> },
    { id: "contact", label: "Contact IQAC", icon: <Phone size={18} /> },
  ];

	const [activeTab, setActiveTab] = useState("about");
	const [news, setNews] = useState([]);
	const [search, setSearch] = useState("");
	const [filteredNews, setFilteredNews] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [images, setImages] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(null);
	
	const senior = {
		  
		name: "Mohammad Taher Hossain Salim",
		designation: " Director",
    mobile: "+88 01975138652",
		    
		email: "iqac@uctc.edu.bd",
		address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
		photo: "assets/teacher/Taher.UCTC.jpeg",
		details: "#",
	};
	const officers = [    
    
    
	{
      name: "Mohammad Injamul Hoq",
      designation: "Additional Director",      
      mobile: "+8801951060585",
      email: " injamul@uctc.edu.bd",
      address: "Chandgaon Police Station, 1084, Shah Amanat Bridge Connecting Road, Chittagong 4212",
      photo: "assets/teacher/97-2003003-inzamamun.jpg",
      details: "#",
    },
	
  ];
	const newsPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:"10",
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/recent-news", payload);
			const data = response.data.slice(0, 48);
			
			// Loop data (array)
			setNews(response.data || []);
			setFilteredNews(data);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const galleryPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'10',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },				
			});
			const response = await api.post("/gallery", payload);			
			
			// Loop data (array)
			setImages(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	useEffect(() => {		
		newsPost();
		galleryPost();
	}, []);
	
	useEffect(() => {
		let result = news;

		if (search) {
			result = result.filter((n) =>
				String(n.date || "").toLowerCase().includes(search.toLowerCase()) ||
				String(n.head_line || "").toLowerCase().includes(search.toLowerCase())
			);
		}
		setFilteredNews(result);
	}, [search, news]);
	
	const openLightbox = (index) => setCurrentIndex(index);
	const closeLightbox = () => setCurrentIndex(null);

	const prevImage = () =>
		setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
	const nextImage = () =>
		setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  const content = {
    about: (
	 <>
		<section className="container mx-auto px-6 py-5">
			<h2 className="text-2xl font-bold text-[#014864]">About IQAC</h2>
		</section>
		<AboutIQAC />
	 </>	
    ),
    vision: (
      <p>
      </p>
    ),
    message: (
	  <motion.section
		initial={{ opacity: 0, y: 28 }}
		whileInView={{ opacity: 1, y: 0 }}
		viewport={{ once: true, amount: 0.2 }}
		transition={{ duration: 0.7, ease: "easeOut" }}
		className="relative isolate overflow-hidden rounded-3xl bg-gradient-to-br from-slate-50 via-white to-cyan-50 p-5 sm:p-8 lg:p-10"
	  >
		{/* Decorative background */}
		<motion.div
		  animate={{ y: [0, -12, 0], x: [0, 8, 0] }}
		  transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -right-16 -top-16 -z-10 h-64 w-64 rounded-full bg-cyan-200/30 blur-3xl"
		/>

		<motion.div
		  animate={{ y: [0, 14, 0], x: [0, -8, 0] }}
		  transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -bottom-20 -left-16 -z-10 h-64 w-64 rounded-full bg-blue-200/30 blur-3xl"
		/>

		<div className="mx-auto max-w-5xl">
		  {/* Section heading */}
		  <motion.div
			initial={{ opacity: 0, x: -20 }}
			whileInView={{ opacity: 1, x: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
			className="mb-8"
		  >
			<div className="mb-4 inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-white/80 px-4 py-2 text-sm font-semibold text-[#014864] shadow-sm">
			  <Sparkles size={16} className="text-cyan-600" />
			  Leadership Message
			</div>

			<h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
			  Message from the{" "}
			  <span className="bg-gradient-to-r from-[#014864] to-cyan-600 bg-clip-text text-transparent">
				Director, IQAC
			  </span>
			</h2>

			<motion.div
			  initial={{ width: 0 }}
			  whileInView={{ width: 96 }}
			  viewport={{ once: true }}
			  transition={{ duration: 0.8, delay: 0.2 }}
			  className="mt-4 h-1.5 rounded-full bg-gradient-to-r from-[#014864] to-cyan-400"
			/>
		  </motion.div>

		  {/* Message card */}
		  <motion.div
			initial={{ opacity: 0, y: 25 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, amount: 0.2 }}
			transition={{ duration: 0.7, delay: 0.15 }}
			whileHover={{ y: -4 }}
			className="relative overflow-hidden rounded-3xl border border-cyan-100 bg-white/90 p-6 shadow-lg shadow-cyan-900/5 backdrop-blur-sm transition-shadow duration-300 hover:shadow-xl hover:shadow-cyan-900/10 sm:p-9"
		  >
			{/* Top accent */}
			<div className="absolute left-0 top-0 h-1.5 w-full bg-gradient-to-r from-[#014864] via-cyan-500 to-emerald-400" />

			{/* Quote mark */}
			<div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#014864] to-cyan-600 text-4xl font-serif leading-none text-white shadow-lg shadow-cyan-900/20">
			  “
			</div>

			<div className="space-y-5 text-justify text-sm leading-8 text-slate-600 sm:text-base sm:leading-9">
			  <p>
				Welcome to IQAC at University of Creative Technology Chittagong
				(UCTC). The Institutional Quality Assurance Cell (IQAC) of UCTC
				was established in July 2020 in order to ensure quality education
				at the tertiary level and aims to meet the demands of contemporary
				times.
			  </p>

			  <p>
				Since its initiation, UCTC-IQAC is functioning to adopt{" "}
				<span className="font-semibold text-[#014864]">
				  Outcome Based Education (OBE)
				</span>{" "}
				as the central application of the University. It will not only
				incorporate the critical and creative thinking skills among our
				graduates but also help to improve the skills on decision making,
				cognitive flexibility and coordination ability.
			  </p>

			  <p>
				UCTC aims to initiate the culture of evidence-based quality
				education and create sustainable environment by prioritizing
				need-based research. I seek your valuable support and cooperation
				in this journey of IQAC and I truly hope, with your support, IQAC
				at UCTC can become a center of excellency in the Higher Education
				sector of Bangladesh.
			  </p>
			</div>

			{/* Closing quote */}
			<div className="mt-6 flex justify-end">
			  <motion.div
				animate={{ rotate: [0, 5, 0] }}
				transition={{
				  duration: 4,
				  repeat: Infinity,
				  ease: "easeInOut",
				}}
				className="text-6xl font-serif leading-none text-cyan-200"
			  >
				”
			  </motion.div>
			</div>

			{/* Signature */}
			<div className="mt-2 border-t border-cyan-100 pt-6">
			  <div className="flex items-center gap-4">
				<div className="h-12 w-1.5 rounded-full bg-gradient-to-b from-[#014864] to-cyan-400" />

				<div>
				  <p className="text-lg font-bold text-slate-900">
					Director, IQAC
				  </p>
				  <p className="mt-1 text-sm font-medium text-slate-500">
					University of Creative Technology Chittagong (UCTC)
				  </p>
				</div>
			  </div>
			</div>
		  </motion.div>
		</div>
	  </motion.section>
	),
    services: (
		<div className="w-full animate-fadeInRight">
            
        </div>
    ),
    gallery: (
		<section className="container mx-auto px-6 py-16">
        {images.length === 0 ? (
          <p className="text-center text-gray-500">{loading ? "Loading gallery..." : "No gallery images available."}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {images.map((img, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                viewport={{ once: true }}
                onClick={() => openLightbox(i)}
                className="relative overflow-hidden rounded-xl shadow-lg group cursor-pointer"
              >
                <img
                  src={`${import.meta.env.VITE_API_SOURCE_URL}${img.picture}`}
                  alt={img.title}
                  className="w-full h-64 object-cover transform group-hover:scale-110 transition duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition">
                  <h3 className="text-lg font-semibold">{img.title}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    ),
    
	news: (
       <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-[#014864]">Latest News</h2>

          {/* Search Box */}
          <input
            type="text"
            placeholder="Search news..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mt-3 md:mt-0 border border-gray-300 rounded-lg px-4 py-2 w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {filteredNews.length > 0 ? (
            filteredNews.map((item) => (
              <div
                key={item.id}
                className="bg-white rounded-xl shadow hover:shadow-lg transition duration-300 overflow-hidden"
              >
                {/* Image */}
                <img
                  src={
                    item.images_path
                      ? import.meta.env.VITE_API_SOURCE_URL + item.images_path
                      : "https://via.placeholder.com/400x250?text=No+Image"
                  }
                  alt={item.head_line}
                  className="w-full h-48 object-cover"
                />

                {/* Content */}
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2 line-clamp-2">
                    {item.head_line}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3">
                    {new Date(item.date).toLocaleDateString()}
                  </p>

                  <Link
                    to={`/news/${item.id}`}
                    className="inline-block bg-[#014864] text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-gray-700 transition"
                  >
                    Read More
                  </Link>
                </div>
              </div>
            ))
          ) : (
            <p className="col-span-4 text-center text-gray-500">
              No news found.
            </p>
          )}
        </div>
      </div>
    ),
	team: (
	  <div className="relative isolate overflow-hidden rounded-3xl bg-gradient-to-br from-slate-50 via-white to-cyan-50 px-4 py-10 sm:px-8 lg:px-10">
		{/* Decorative background */}
		<motion.div
		  animate={{ y: [0, -14, 0], x: [0, 10, 0] }}
		  transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -right-20 -top-20 -z-10 h-72 w-72 rounded-full bg-cyan-200/30 blur-3xl"
		/>
		<motion.div
		  animate={{ y: [0, 12, 0], x: [0, -8, 0] }}
		  transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -bottom-20 -left-20 -z-10 h-72 w-72 rounded-full bg-blue-200/30 blur-3xl"
		/>

		<div className="mx-auto max-w-7xl">
		  {/* Heading */}
		  <motion.div
			initial={{ opacity: 0, y: 25 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true, amount: 0.2 }}
			transition={{ duration: 0.65 }}
			className="mb-10 text-center"
		  >
			<span className="inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-white/80 px-4 py-2 text-sm font-semibold text-[#014864] shadow-sm">
			  <Users size={16} className="text-cyan-600" />
			  Meet Our Team
			</span>

			<h2 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
			  IQAC{" "}
			  <span className="bg-gradient-to-r from-[#014864] to-cyan-600 bg-clip-text text-transparent">
				Leadership & Team
			  </span>
			</h2>

			<motion.div
			  initial={{ width: 0 }}
			  whileInView={{ width: 96 }}
			  viewport={{ once: true }}
			  transition={{ duration: 0.8, delay: 0.2 }}
			  className="mx-auto mt-4 h-1.5 rounded-full bg-gradient-to-r from-[#014864] to-cyan-400"
			/>

			<p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
			  Meet the dedicated professionals working to promote quality
			  assurance and academic excellence at UCTC.
			</p>
		  </motion.div>

		  {/* Senior profile */}
		  <motion.div
			initial={{ opacity: 0, y: 35, scale: 0.97 }}
			whileInView={{ opacity: 1, y: 0, scale: 1 }}
			viewport={{ once: true, amount: 0.2 }}
			transition={{ duration: 0.7 }}
			whileHover={{ y: -5 }}
			className="group relative mb-12 overflow-hidden rounded-3xl border border-cyan-100 bg-white shadow-xl shadow-cyan-900/5 transition-shadow duration-300 hover:shadow-2xl hover:shadow-cyan-900/10"
		  >
			{/* Top gradient strip */}
			<div className="h-2 w-full bg-gradient-to-r from-[#014864] via-cyan-500 to-emerald-400" />

			<div className="grid items-center gap-8 p-6 sm:p-8 md:grid-cols-[260px_1fr] lg:gap-12 lg:p-10">
			  {/* Photo */}
			  <div className="relative mx-auto w-full max-w-[240px]">
				<motion.div
				  animate={{ rotate: [0, 2, 0, -2, 0] }}
				  transition={{
					duration: 8,
					repeat: Infinity,
					ease: "easeInOut",
				  }}
				  className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-cyan-200 to-blue-200 opacity-60 blur-sm"
				/>

				<div className="relative overflow-hidden rounded-2xl border-4 border-white shadow-lg">
				  <img
					src={`${import.meta.env.VITE_API_SOURCE_URL}${senior.photo}`}
					alt={senior.name}
					className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-105"
				  />
				</div>

				<div className="absolute -bottom-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gradient-to-r from-[#014864] to-cyan-600 px-5 py-2 text-xs font-bold uppercase tracking-wider text-white shadow-lg">
				  IQAC Leadership
				</div>
			  </div>

			  {/* Details */}
			  <div className="pt-3 text-center md:text-left">
				<span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-700">
				  Senior Leadership
				</span>

				<h3 className="mt-3 text-2xl font-extrabold text-slate-900 sm:text-3xl">
				  {senior.name}
				</h3>

				<p className="mt-2 text-lg font-semibold text-[#014864]">
				  {senior.designation}
				</p>

				<p className="mt-2 text-sm text-slate-500">{senior.office}</p>

				<div className="mt-6 grid gap-3 text-sm text-slate-600 sm:grid-cols-2">
				  <div className="flex items-center justify-center gap-3 rounded-xl bg-slate-50 p-3 md:justify-start">
					<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-cyan-100 text-[#014864]">
					  <Phone size={16} />
					</span>
					<span className="break-all">{senior.mobile}</span>
				  </div>

				  <div className="flex items-center justify-center gap-3 rounded-xl bg-slate-50 p-3 md:justify-start">
					<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-cyan-100 text-[#014864]">
					  <Mail size={16} />
					</span>
					<span className="break-all">{senior.email}</span>
				  </div>

				  <div className="flex items-center justify-center gap-3 rounded-xl bg-slate-50 p-3 sm:col-span-2 md:justify-start">
					<span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-cyan-100 text-[#014864]">
					  <MapPin size={16} />
					</span>
					<span>{senior.address}</span>
				  </div>
				</div>

				<a
				  href={senior.details}
				  className="group/button mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#014864] to-cyan-600 px-6 py-3 text-sm font-bold text-white shadow-lg shadow-cyan-900/15 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
				>
				  View Details
				  <ArrowUpRight
					size={17}
					className="transition-transform duration-300 group-hover/button:translate-x-1 group-hover/button:-translate-y-1"
				  />
				</a>
			  </div>
			</div>
		  </motion.div>

		  {/* Officer section heading */}
		  <motion.div
			initial={{ opacity: 0, x: -20 }}
			whileInView={{ opacity: 1, x: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
			className="mb-7"
		  >
			<span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-700">
			  Our Professionals
			</span>

			<h3 className="mt-2 text-2xl font-extrabold text-slate-900 sm:text-3xl">
			  IQAC Officers
			</h3>

			<p className="mt-2 max-w-2xl text-sm leading-7 text-slate-500">
			  The team supporting the IQAC’s ongoing activities and quality
			  assurance initiatives.
			</p>
		  </motion.div>

		  {/* Officer cards */}
		  <motion.div
			initial="hidden"
			whileInView="visible"
			viewport={{ once: true, amount: 0.1 }}
			variants={{
			  hidden: {},
			  visible: {
				transition: { staggerChildren: 0.12 },
			  },
			}}
			className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
		  >
			{officers.map((officer, index) => (
			  <motion.div
				key={officer.email || index}
				variants={{
				  hidden: { opacity: 0, y: 35 },
				  visible: { opacity: 1, y: 0 },
				}}
				transition={{ duration: 0.55, ease: "easeOut" }}
				whileHover={{ y: -8 }}
				className="group relative overflow-hidden rounded-2xl border border-cyan-100 bg-white shadow-md shadow-slate-900/5 transition-all duration-300 hover:border-cyan-300 hover:shadow-xl hover:shadow-cyan-900/10"
			  >
				{/* Card accent */}
				<div className="h-1.5 w-full bg-gradient-to-r from-[#014864] to-cyan-400" />

				<div className="p-6 text-center">
				  {/* Officer photo */}
				  <div className="relative mx-auto mb-5 h-40 w-32">
					<div className="absolute -inset-2 rounded-2xl bg-gradient-to-br from-cyan-200 to-blue-200 opacity-50 blur-sm transition-opacity duration-300 group-hover:opacity-90" />

					<div className="relative h-full overflow-hidden rounded-xl border-4 border-white shadow-md">
					  <img
						src={`${import.meta.env.VITE_API_SOURCE_URL}${officer.photo}`}
						alt={officer.name}
						className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
					  />
					</div>
				  </div>

				  <h4 className="text-lg font-bold text-slate-900 transition-colors group-hover:text-[#014864]">
					{officer.name}
				  </h4>

				  <p className="mt-2 min-h-10 text-sm font-semibold leading-5 text-cyan-700">
					{officer.designation}
				  </p>

				  <div className="my-4 h-px bg-gradient-to-r from-transparent via-cyan-200 to-transparent" />

				  <div className="space-y-3 text-left text-sm text-slate-600">
					<p className="flex items-start gap-3">
					  <Phone
						size={15}
						className="mt-0.5 shrink-0 text-cyan-700"
					  />
					  <span className="break-all">{officer.mobile}</span>
					</p>

					<p className="flex items-start gap-3">
					  <Mail
						size={15}
						className="mt-0.5 shrink-0 text-cyan-700"
					  />
					  <span className="break-all">{officer.email}</span>
					</p>

					<p className="flex items-start gap-3">
					  <MapPin
						size={15}
						className="mt-0.5 shrink-0 text-cyan-700"
					  />
					  <span>{officer.address}</span>
					</p>
				  </div>

				  <a
					href={officer.details}
					className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl border border-cyan-200 bg-cyan-50 px-4 py-3 text-sm font-bold text-[#014864] transition-all duration-300 hover:border-[#014864] hover:bg-[#014864] hover:text-white"
				  >
					View Details
					<ArrowUpRight
					  size={16}
					  className="transition-transform duration-300 group-hover:translate-x-1"
					/>
				  </a>
				</div>
			  </motion.div>
			))}
		  </motion.div>
		</div>
	  </div>
	),
	psac: (
	  <>
		<section className="container mx-auto px-6 py-5">
			<h2 className="text-2xl font-bold text-[#014864]">Program Staff Assessment Committee (PSAC)</h2>
		</section>
		<PSACSection />
	  </>
	),
    contact: (
	  <motion.section
		initial={{ opacity: 0, y: 25 }}
		whileInView={{ opacity: 1, y: 0 }}
		viewport={{ once: true, amount: 0.2 }}
		transition={{ duration: 0.7, ease: "easeOut" }}
		className="relative isolate overflow-hidden rounded-3xl bg-gradient-to-br from-slate-50 via-white to-cyan-50 px-4 py-10 sm:px-8 lg:px-10"
	  >
		{/* Animated background accents */}
		<motion.div
		  animate={{ y: [0, -14, 0], x: [0, 8, 0] }}
		  transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -right-20 -top-20 -z-10 h-72 w-72 rounded-full bg-cyan-200/30 blur-3xl"
		/>

		<motion.div
		  animate={{ y: [0, 12, 0], x: [0, -8, 0] }}
		  transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
		  className="pointer-events-none absolute -bottom-20 -left-20 -z-10 h-72 w-72 rounded-full bg-blue-200/30 blur-3xl"
		/>

		<div className="mx-auto max-w-6xl">
		  {/* Heading */}
		  <motion.div
			initial={{ opacity: 0, y: 20 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
			className="mb-8 text-center"
		  >
			<span className="inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-white/80 px-4 py-2 text-sm font-semibold text-[#014864] shadow-sm">
			  <Mail size={16} className="text-cyan-600" />
			  Get in Touch
			</span>

			<h2 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
			  Contact{" "}
			  <span className="bg-gradient-to-r from-[#014864] to-cyan-600 bg-clip-text text-transparent">
				IQAC
			  </span>
			</h2>

			<motion.div
			  initial={{ width: 0 }}
			  whileInView={{ width: 96 }}
			  viewport={{ once: true }}
			  transition={{ duration: 0.8, delay: 0.2 }}
			  className="mx-auto mt-4 h-1.5 rounded-full bg-gradient-to-r from-[#014864] to-cyan-400"
			/>

			<p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-slate-500 sm:text-base">
			  Contact the Institutional Quality Assurance Cell at the University
			  of Creative Technology Chittagong.
			</p>
		  </motion.div>

		  {/* Contact card */}
		  <motion.div
			initial={{ opacity: 0, y: 30, scale: 0.98 }}
			whileInView={{ opacity: 1, y: 0, scale: 1 }}
			viewport={{ once: true, amount: 0.2 }}
			transition={{ duration: 0.7, delay: 0.1 }}
			whileHover={{ y: -4 }}
			className="relative overflow-hidden rounded-3xl border border-cyan-100 bg-white/90 shadow-xl shadow-cyan-900/5 backdrop-blur-sm transition-shadow duration-300 hover:shadow-2xl hover:shadow-cyan-900/10"
		  >
			{/* Top accent */}
			<div className="h-2 w-full bg-gradient-to-r from-[#014864] via-cyan-500 to-emerald-400" />

			<div className="grid md:grid-cols-[0.85fr_1.15fr]">
			  {/* Left panel */}
			  <div className="relative overflow-hidden bg-gradient-to-br from-[#014864] to-[#087b9a] p-7 text-white sm:p-9">
				<motion.div
				  animate={{ rotate: 360 }}
				  transition={{ duration: 35, repeat: Infinity, ease: "linear" }}
				  className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full border border-white/10"
				/>

				<motion.div
				  animate={{ rotate: -360 }}
				  transition={{ duration: 45, repeat: Infinity, ease: "linear" }}
				  className="pointer-events-none absolute -bottom-24 -left-20 h-72 w-72 rounded-full border border-white/10"
				/>

				<div className="relative">
				  <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl border border-white/20 bg-white/10 backdrop-blur-sm">
					<MapPin size={26} />
				  </div>

				  <p className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-100">
					Visit Our Office
				  </p>

				  <h3 className="mt-3 text-2xl font-extrabold leading-tight sm:text-3xl">
					Institutional Quality Assurance Cell
				  </h3>

				  <p className="mt-3 text-sm leading-7 text-cyan-50/90">
					University of Creative Technology Chittagong (UCTC)
				  </p>

				  <div className="mt-8 rounded-2xl border border-white/15 bg-white/10 p-4 backdrop-blur-sm">
					<div className="flex items-center gap-3">
					  <Clock size={20} className="shrink-0 text-cyan-100" />
					  <div>
						<p className="text-xs font-semibold uppercase tracking-wider text-cyan-100">
						  Office Hours
						</p>
						<p className="mt-1 text-sm font-semibold">
						  Monday – Saturday
						</p>
						<p className="text-sm text-cyan-50">
						  9:00 AM – 6:00 PM
						</p>
					  </div>
					</div>
				  </div>
				</div>
			  </div>

			  {/* Right panel */}
			  <div className="p-6 sm:p-9">
				<div className="mb-6">
				  <h3 className="text-xl font-bold text-slate-900">
					Contact Information
				  </h3>
				  <p className="mt-2 text-sm leading-6 text-slate-500">
					Reach out to IQAC for information, support, or inquiries.
				  </p>
				</div>

				<div className="space-y-4">
				  {/* Email */}
				  <motion.a
					href="mailto:iqac@uctc.edu.bd"
					whileHover={{ x: 5 }}
					className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-slate-50 p-4 transition-all duration-300 hover:border-cyan-200 hover:bg-cyan-50"
				  >
					<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-100 text-[#014864] transition-all duration-300 group-hover:bg-[#014864] group-hover:text-white">
					  <Mail size={21} />
					</div>

					<div className="min-w-0">
					  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
						Email Address
					  </p>
					  <p className="mt-1 break-all font-semibold text-slate-800">
						iqac@uctc.edu.bd
					  </p>
					</div>

					<ArrowUpRight
					  size={18}
					  className="ml-auto shrink-0 text-slate-400 transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-cyan-700"
					/>
				  </motion.a>

				  {/* Phone */}
				  <motion.a
					href="tel:+8801707507071"
					whileHover={{ x: 5 }}
					className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-slate-50 p-4 transition-all duration-300 hover:border-cyan-200 hover:bg-cyan-50"
				  >
					<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-100 text-[#014864] transition-all duration-300 group-hover:bg-[#014864] group-hover:text-white">
					  <Phone size={21} />
					</div>

					<div className="min-w-0">
					  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
						Phone Number
					  </p>
					  <p className="mt-1 font-semibold text-slate-800">
						+880 1707-507071
					  </p>
					</div>

					<ArrowUpRight
					  size={18}
					  className="ml-auto shrink-0 text-slate-400 transition-all group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-cyan-700"
					/>
				  </motion.a>

				  {/* Location */}
				  <motion.div
					whileHover={{ x: 5 }}
					className="group flex items-start gap-4 rounded-2xl border border-slate-100 bg-slate-50 p-4 transition-all duration-300 hover:border-cyan-200 hover:bg-cyan-50"
				  >
					<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-100 text-[#014864] transition-all duration-300 group-hover:bg-[#014864] group-hover:text-white">
					  <Building2 size={21} />
					</div>

					<div>
					  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
						Office Location
					  </p>
					  <p className="mt-1 font-semibold text-slate-800">
						1st Floor, UCTC Campus
					  </p>
					</div>
				  </motion.div>

				  {/* Mailing address */}
				  <motion.div
					whileHover={{ x: 5 }}
					className="group flex items-start gap-4 rounded-2xl border border-slate-100 bg-slate-50 p-4 transition-all duration-300 hover:border-cyan-200 hover:bg-cyan-50"
				  >
					<div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-100 text-[#014864] transition-all duration-300 group-hover:bg-[#014864] group-hover:text-white">
					  <MapPin size={21} />
					</div>

					<div>
					  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
						Mailing Address
					  </p>
					  <p className="mt-1 text-sm leading-7 text-slate-700">
						Institutional Quality Assurance Cell (IQAC), University of
						Creative Technology, Chittagong, 1084, Near New Chandgaon
						Police Station, Shah Amanat Bridge Connecting Road,
						Bahaddarhat, Chittagong, Bangladesh.
					  </p>
					</div>
				  </motion.div>
				</div>
			  </div>
			</div>
		  </motion.div>
		</div>
	  </motion.section>
	),
  };

  return (
    <div className="min-h-screen overflow-hidden bg-slate-50 text-slate-800">
      {/* Hero */}
      <section className="relative isolate overflow-hidden bg-gradient-to-br from-[#06384c] via-[#014864] to-[#087c9b] px-4 pb-24 pt-16 text-white sm:px-6 md:pb-28 md:pt-24">
        <div className="pointer-events-none absolute inset-0 opacity-25">
          <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-cyan-300 blur-3xl" />
          <div className="absolute -right-20 top-20 h-96 w-96 rounded-full bg-sky-400 blur-3xl" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.16)_1px,transparent_0)] [background-size:26px_26px]" />
        </div>
        <motion.div
          aria-hidden="true"
          animate={{ y: [0, -15, 0], rotate: [0, 5, 0] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          className="absolute left-[7%] top-24 hidden h-20 w-20 rounded-3xl border border-white/20 bg-white/10 backdrop-blur md:block"
        />
        <motion.div
          aria-hidden="true"
          animate={{ y: [0, 14, 0], rotate: [0, -6, 0] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          className="absolute right-[9%] bottom-20 hidden h-28 w-28 rounded-full border border-white/20 bg-white/10 backdrop-blur md:block"
        />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative mx-auto max-w-7xl text-center"
        >
          <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-cyan-100/25 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-cyan-100 backdrop-blur sm:text-sm">
            <Sparkles size={16} />
            University of Creative Technology Chittagong
          </div>
          <h1 className="mx-auto max-w-5xl text-balance text-3xl font-black leading-tight sm:text-4xl md:text-6xl">
            Institutional Quality
            <span className="block text-cyan-200">Assurance Cell (IQAC)</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-7 text-sky-100 sm:text-lg">
            Promoting continuous improvement, evidence-based quality education,
            and sustainable academic excellence at UCTC.
          </p>
          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => setActiveTab("about")}
              className="group inline-flex items-center justify-center gap-2 rounded-xl bg-white px-6 py-3.5 font-bold text-[#014864] shadow-lg transition hover:-translate-y-1 hover:bg-cyan-50"
            >
              Explore IQAC
              <ArrowRight size={18} className="transition group-hover:translate-x-1" />
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("contact")}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/30 bg-white/10 px-6 py-3.5 font-bold text-white backdrop-blur transition hover:-translate-y-1 hover:bg-white/20"
            >
              <Phone size={17} />
              Contact IQAC
            </button>
          </div>
        </motion.div>
        <svg
          aria-hidden="true"
          className="absolute bottom-0 left-0 h-14 w-full text-slate-50 sm:h-20"
          viewBox="0 0 1440 120"
          preserveAspectRatio="none"
        >
          <path fill="currentColor" d="M0,64 C240,120 480,10 720,58 C960,108 1200,18 1440,64 L1440,120 L0,120 Z" />
        </svg>
      </section>

      {/* Intro highlights */}
      <section className="relative z-10 mx-auto -mt-3 max-w-8xl px-4 sm:px-6">
        <div className="grid gap-4 sm:grid-cols-3">
          {[
            { icon: <ShieldCheck size={22} />, title: "Quality Assurance", text: "A culture of continuous quality enhancement" },
            { icon: <BookOpen size={22} />, title: "Academic Excellence", text: "Supporting effective teaching and learning" },
            { icon: <Users size={22} />, title: "Stakeholder Engagement", text: "Working with students, alumni, and employers" },
          ].map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
              whileHover={{ y: -5 }}
              className="flex items-center gap-4 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-[0_12px_35px_-25px_rgba(1,72,100,0.5)]"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-50 text-[#087c9b]">
                {item.icon}
              </span>
              <div>
                <h2 className="font-extrabold text-slate-800">{item.title}</h2>
                <p className="mt-1 text-sm leading-5 text-slate-500">{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Navigation and content */}
      <section className="mx-auto grid w-full min-w-0 max-w-8xl gap-6 overflow-hidden px-4 py-10 sm:px-6 md:py-14 lg:grid-cols-[300px_minmax(0,1fr)]">
        <aside className="h-fit w-full min-w-0 max-w-full overflow-hidden rounded-2xl border border-slate-200 bg-white p-3 shadow-sm lg:sticky lg:top-24">
          <div className="px-3 pb-3 pt-2">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-cyan-700">Explore</p>
            <h2 className="mt-1 text-lg font-black text-slate-800">IQAC Sections</h2>
          </div>
          <nav aria-label="IQAC sections">
            <ul className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-visible lg:pb-0">
              {tabs.map((tab) => {
                const selected = activeTab === tab.id;
                return (
                  <li key={tab.id} className="w-auto min-w-max flex-none lg:w-full lg:min-w-0 lg:flex-auto">
                    <button
                      type="button"
                      onClick={() => setActiveTab(tab.id)}
                      aria-current={selected ? "page" : undefined}
                      className={`group relative flex w-auto min-w-max items-center gap-3 rounded-xl px-3 py-3 text-left text-sm font-semibold transition duration-200 lg:w-full lg:min-w-0 ${
                        selected
                          ? "bg-[#014864] text-white shadow-md shadow-cyan-900/15"
                          : "text-slate-600 hover:bg-cyan-50 hover:text-[#014864]"
                      }`}
                    >
                      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                        selected ? "bg-white/15 text-cyan-100" : "bg-slate-100 text-slate-500 group-hover:bg-cyan-100 group-hover:text-[#014864]"
                      }`}>
                        {tab.icon}
                      </span>
                      <span className="whitespace-nowrap lg:whitespace-normal lg:break-words">{tab.label}</span>
                      {selected && (
                        <motion.span
                          layoutId="iqac-active-tab"
                          className="absolute inset-y-2 left-0 w-1 rounded-r-full bg-cyan-300"
                        />
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
          <div className="mt-4 hidden rounded-xl bg-gradient-to-br from-cyan-50 to-sky-50 p-4 lg:block">
            <p className="text-sm font-bold text-[#014864]">Have a question?</p>
            <p className="mt-1 text-xs leading-5 text-slate-500">Reach out to the IQAC office for information and assistance.</p>
            <button
              type="button"
              onClick={() => setActiveTab("contact")}
              className="mt-3 inline-flex items-center gap-2 text-sm font-bold text-cyan-800 hover:text-cyan-600"
            >
              Contact us <ArrowRight size={15} />
            </button>
          </div>
        </aside>

        <motion.main
          key={activeTab}
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="w-full min-w-0 max-w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
        >
          <div className="border-b border-slate-100 bg-gradient-to-r from-cyan-50/80 via-white to-white px-5 py-5 sm:px-8">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#014864] text-cyan-100 shadow-sm">
                {tabs.find((tab) => tab.id === activeTab)?.icon}
              </span>
              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-cyan-700">UCTC • IQAC</p>
                <h2 className="mt-1 min-w-0 break-words text-xl font-black text-slate-800 sm:text-2xl">
                  {tabs.find((tab) => tab.id === activeTab)?.label}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-5 sm:p-8">
            <div className="max-w-none text-[15px] leading-7 text-slate-600 [&_h2]:mb-4 [&_h2]:text-2xl [&_h2]:font-extrabold [&_h2]:text-[#014864] [&_h3]:font-bold [&_h3]:text-[#014864] [&_p]:mb-4 [&_strong]:font-bold [&_strong]:text-slate-800">
              {content[activeTab]}
            </div>
          </div>
        </motion.main>
      </section>

      {/* Gallery lightbox */}
      <AnimatePresence>
        {currentIndex !== null && images[currentIndex] && (
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/95 p-4 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeLightbox}
          >
            <button
              type="button"
              onClick={closeLightbox}
              aria-label="Close image"
              className="absolute right-5 top-5 rounded-full bg-white/10 p-3 text-white transition hover:bg-white/20"
            >
              <X size={25} />
            </button>
            <button
              type="button"
              onClick={(event) => { event.stopPropagation(); prevImage(); }}
              aria-label="Previous image"
              className="absolute left-3 rounded-full bg-white/10 p-3 text-white transition hover:bg-white/20 sm:left-6"
            >
              <ChevronLeft size={28} />
            </button>
            <motion.div
              key={currentIndex}
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.92, opacity: 0 }}
              transition={{ duration: 0.25 }}
              className="max-w-[90vw] text-center"
              onClick={(event) => event.stopPropagation()}
            >
              <img
                src={`${import.meta.env.VITE_API_SOURCE_URL}${images[currentIndex].picture}`}
                alt={images[currentIndex].title || "IQAC gallery image"}
                className="mx-auto max-h-[78vh] max-w-full rounded-2xl object-contain shadow-2xl"
              />
              <p className="mt-4 text-base font-semibold text-white sm:text-lg">
                {images[currentIndex].title}
              </p>
              <p className="mt-1 text-xs text-white/60">{currentIndex + 1} / {images.length}</p>
            </motion.div>
            <button
              type="button"
              onClick={(event) => { event.stopPropagation(); nextImage(); }}
              aria-label="Next image"
              className="absolute right-3 rounded-full bg-white/10 p-3 text-white transition hover:bg-white/20 sm:right-6"
            >
              <ChevronRight size={28} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>

      <footer className="border-t border-slate-200 bg-white px-4 py-6 text-center text-sm text-slate-500">
        Institutional Quality Assurance Cell (IQAC) • University of Creative Technology Chittagong
      </footer>
    </div>
  );
}
